import '../shared/index';
import './components';
import './stores';

import {
  makeCarousel,
  makeUnmountedCarousel,
} from '../../auto/utils/carousel/splide';

import fcaServiceApi from '../../auto/utils/fcaServiceApi';
import { makeAllDdmOffersListSyncService } from '../../auto/services/DdmServiceV2/makeAllDdmOffersListSyncService';
import { DDMAdapter } from '../../auto/services/ddm_service/adapters/ddmAdapter';
import { addExceptionModelsToChannelData } from '../../auto/services/ddm_service/utils';
import { renderFeaturesDisplay } from '../../auto/utils/featuresDisplay';
import { setViewItemEventOnNewVehiclePageLoad } from '../../auto/utils/setViewItemEventOnNewVehiclePageLoad';

import { NewVehiclesAdapter } from '../../auto/services/ddm_data_layer_service/adapters/newVehiclesAdapter';
import { newVehicleShowEvents } from '../../auto/services/click_attacher_service/events/jeepEventsConfiguration';

window.makeCarousel = makeCarousel;
window.makeUnmountedCarousel = makeUnmountedCarousel;
window.serviceFca = fcaServiceApi;

window.DDMAdapter = DDMAdapter;
window.ddmOffersListSyncService = makeAllDdmOffersListSyncService();

window.helpers = {
  ...window.helpers,
  addExceptionModelsToChannelData,
  setViewItemEventOnNewVehiclePageLoad,
};

window.renderFeaturesDisplay = renderFeaturesDisplay;
window.DDMDataLayerHelpers = {
  NewVehiclesAdapter,
};

window.attachClickEvents(window.DDMDataLayerService, [...newVehicleShowEvents]);
